import { createFetch } from "@vueuse/core";

const url = process.env.VUE_APP_FILMIN_WEB_LINK;

export const wapiClient = createFetch({
  baseUrl: url,
  options: {
    async beforeFetch({ options }) {
      options.credentials = "include";
      options.headers = {
        ...options.headers,
        "X-Requested-With": "XMLHttpRequest",
      };
      return { options };
    },
  },
});
